<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <StationInfo ref="info" :bus-item="haierItem"></StationInfo>

    <div style="margin: 10px 0 0 8px">
      <el-form v-if="haierItem['file@image_library']" style="padding-left: 10px">
        <el-form-item label="图片库" label-width="130px">
          <div class="imgDiv">
            <el-image
                v-for="item in haierItem['file@image_library']"
                :key="item.id"
                :src="item.url"
                :preview-src-list="[item.url]"
                @click="imageClick(item)"
            ></el-image>
          </div>
        </el-form-item>
      </el-form>
      <FrameForm ref="frameForm" :component-param="componentParam" :parent-data="{id:haierItem.id,station_id:stationId}"
                 :init-data="{'file@image_library':haierItem['file@image_library']}"></FrameForm>
    </div>
  </div>
</template>

<script>
import StationInfo from "@/views/applications/haier/StationInfo.vue";

export default {
  name: "StationParent",
  components: {StationInfo},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      sn: '',
      canWork: false,
      loading: false,
      haierItem: {},
      viewImageIds: []
    }
  },
  computed: {
    stationId() {
      if (this.componentParam && this.componentParam.length > 6) {
        return this.componentParam.substring(6);
      }
      return '';
    }
  },
  provide() {
    let that = this;
    return {
      $fn: {
        reset: () => {
          this.sn = ''
          this.reset();
        },
        checkImageLibrary() {
          let list = that.haierItem['file@image_library'];
          if (!list || list.length == 0) {
            return true;
          }
          for (let item of list) {
            if (!that.viewImageIds.includes(item.id)) {
              this.showMessage('error', '请依次点开图片库照片进行核对');
              return false;
            }
          }
          return true;
        }
      }
    }
  },
  methods: {
    search() {
      this.reset()
      this.$refs.frameForm.formInfo = {} //清空作业表单内容
      this.$refs.frameForm.clearMessage()

      if (!this.sn) {
        return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      this.$http('haierItemService.queryStationInfo', {
        station_id: this.stationId,
        sn: this.sn
      }, false).then(data => {
        this.loading = false
        this.haierItem = data.haierItem || {}
        this.canWork = true
        this.$refs.frameForm.initForm()
        return this.$refs.searchMessage.showSuccess('状态正常，请作业');
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })


    },
    reset() {
      this.haierItem = {}
      this.canWork = false
      this.viewImageIds = []
      this.$refs.searchMessage.clear()

    },
    imageClick(item) {
      this.viewImageIds.push(item.id)
      console.log(this.viewImageIds)
    }
  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: right;
}

.login-user {
  position: absolute;
  right: 10px;
}


.imgDiv {
  border: solid 1px #e5e5e5;
  padding: 5px;
  height: 136px;
}

.imgDiv .el-image {
  width: 130px;
  height: 130px;
  padding: 3px
}

</style>